import { connect } from 'react-redux';

import JavascriptDisabledAlert from 'apps/browserWarnings/components/JavascriptDisabledAlert';

export default connect(
  state => ({
    pageView: state.analytics.pageView,
  })
)(JavascriptDisabledAlert);
